var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1417 11.7073C15.3746 11.7073 17.9954 9.08654 17.9954 5.85366C17.9954 2.62078 15.3746 0 12.1417 0C8.90886 0 6.28809 2.62078 6.28809 5.85366C6.28809 9.08654 8.90886 11.7073 12.1417 11.7073Z",
    fill: "#5A6872"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.142 14.6342C6.27659 14.6342 1.5 18.5678 1.5 23.4146C1.5 23.7424 1.75756 24 2.08537 24H22.1986C22.5264 24 22.7839 23.7424 22.7839 23.4146C22.7839 18.5678 18.0074 14.6342 12.142 14.6342Z",
    fill: "#5A6872"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.19ff00362b3813b6f787eb40850e223d.svg";
export { ForwardRef as ReactComponent };